import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { I18nextProvider } from "react-i18next";
import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { BreakpointProvider } from './context/BreakpointContext';

import loginForm_en from './components/LoginForm/i18n/LoginForm_en.json';
import loginForm_de from './components/LoginForm/i18n/LoginForm_de.json';
import langPicker_de from './components/UI/LangPicker/i18n/LangPicker_de.json';
import langPicker_en from './components/UI/LangPicker/i18n/LangPicker_en.json';
import successDialog_de from './components/Dialog/i18n/SuccessDialog_de.json';
import successDialog_en from './components/Dialog/i18n/SuccessDialog_en.json';
import errorDialog_de from './components/Dialog/i18n/ErrorDialog_de.json';
import errorDialog_en from './components/Dialog/i18n/ErrorDialog_en.json';

i18next
    .use(LanguageDetector)
    .init({
        'interpolation': { 'escapeValue': false },
        'fallbackLng': ['en', 'de'],
        'lng': 'de',
        'resources': {
            'en': {
                'loginForm': loginForm_en,
                'langPicker': langPicker_en,
                'successDialog': successDialog_en,
                'errorDialog': errorDialog_en,
            },
            'de': {
                'loginForm': loginForm_de,
                'langPicker': langPicker_de,
                'successDialog': successDialog_de,
                'errorDialog': errorDialog_de,
            },
        },
    });

const queries = {
    s: '(max-width: 767px)',
    l: '(min-width: 768px)',
};

// Get the application-wide store instance, prepopulating with state from the server where available.
ReactDOM.render(
    <BreakpointProvider queries={queries}>
        <I18nextProvider i18n={i18next}>
            <App />
        </I18nextProvider>
    </BreakpointProvider>,
    document.getElementById('root'));

registerServiceWorker();
